// @flow

import { resolverGroupActions } from "./resolverGroupActionCreator";

const initialState = {
  locationData: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  userDataByLocation: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  groupData: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  group: {
    isLoading: false,
    isLoaded: false,
    data: null,
    allowAPIcall: true
  }
};

const resolverGroupReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case resolverGroupActions.GET_LOCATION_DATA: {
      return Object.assign({}, state, { locationData: action.payload });
    }
    case resolverGroupActions.GET_USER_DATA_BY_LOCATION: {
      return Object.assign({}, state, { userDataByLocation: action.payload });
    }
    case resolverGroupActions.GET_GROUPS: {
      return Object.assign({}, state, {
        groupData: action.payload
      });
    }
    case resolverGroupActions.CREATE_GROUP: {
      return Object.assign({}, state, { group: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default resolverGroupReducer;



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/resolverGroup/resolverGroupRedux/resolverGroupReducer.js